// project-imports
import { getRequest, postRequest, postRequestStrict } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - COGNITO ||============================== //

export async function registrationCompleted(email: string): Promise<void> {
  await postRequestStrict(
    '/cognito/registration-completed',
    { email },
    {
      successStatus: 200,
      successMessage: 'Registration completion accepted',
      retryStatuses: [429, 503],
      retries: 2
    }
  );
}

export async function handleCognito(action: APIAction) {
  switch (action.method) {
    case 'create-member-user':
      return postRequest('/cognito/create-member-user', action.data);
    case 'delete-member-user':
      return postRequest('/cognito/delete-member-user', action.data);
    case 'create-password':
      return postRequest('/cognito/create-password', action.data);
    case 'create-password-sales':
      return postRequest('/sales/create-password', action.data);
    case 'renew-create-password-freemium-token':
      return postRequest('/cognito/renew-create-password-freemium-token', action.data, true);
    case 'renew-create-password-international-token':
      return postRequest('/cognito/renew-create-password-international-token', action.data, true);
    case 'create-user-freemium-international':
      return postRequest('/cognito/create-user-freemium-international', action.data, true);
    case 'activate-offer':
      return postRequest('/cognito/activate-offer', action.data, true);
    case 'partner-apps':
      return postRequest('/cognito/partner-apps', action.data);
    case 'registration-completed':
      return registrationCompleted(action.data.email);
    case 'check-email':
      return getRequest(`/cognito/check-email?email=${action.data.email}`);
    case 'user-details': {
      const username = encodeURIComponent(action.data.username);
      const includeChildren = action.data?.includeChildren ? 'true' : 'false';
      return getRequest(`/cognito/user-details?username=${username}&include_children=${includeChildren}`);
    }
    default:
      console.info('[ApiManager > handleApiAction > handleCognito] - Unknown method');
      break;
  }
}
